import { useAccount } from '@/hooks/useAccount';

import PaywallFastPayTabs from '../FastPayTabs/FastPayTabs';
import PaywallFastPayTabsMan from '../FastPayTabsMan/FastPayTabsMan';

const PaywallFastPayTabsMultigender: React.FC = () => {
  const { user } = useAccount();

  if (user?.onboarding_data.gender === 'male') {
    return <PaywallFastPayTabsMan />;
  }

  return <PaywallFastPayTabs />;
};

export default PaywallFastPayTabsMultigender;
